import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  institution: {},
  publicInstitution: {},
  packages: [],
  allPragyaPackages: [],
  enabledFeatures: {},
  institutionLabels: {},
  termMapWithCutOffDate: {},
  partnerInstitutions: [],
  selfRegistrationLink: '',
  selfSigninLink:''
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/institution/vuex/index.js